import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

import React, { useState } from 'react';
import { Box, Image, Heading, Text } from '@chakra-ui/react';
import ReactPlayer from 'react-player';

const Video = ({ sectionContent }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box
        position="relative"
        width={{ base: '100%', md: '84%', lg: '80%', xl: '1050px' }}
        height={{
          base: '200px',
          sm: '400px',
          md: '330px',
          lg: '400',
          xl: '461.51px',
        }}
      >
        {/* Video Player */}
        <ReactPlayer
          url={sectionContent.embedUrl}
          playing={isVideoPlaying}
          width="100%"
          height="100%"
          controls
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />

        {/* Overlay Image */}
        {!isVideoPlaying && (
          <Box
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            onClick={handlePlayVideo}
            cursor="pointer"
            role="button"
            aria-label="Play video"
            tabIndex={0}
            onKeyPress={e => {
              if (e.key === 'Enter') handlePlayVideo();
            }}
          >
            <Image
              src={
                sectionContent.image?.url ||
                'https://via.placeholder.com/1050x488'
              }
              alt={sectionContent.image?.alt || 'Video Thumbnail'}
              width="100%"
              height="100%"
              objectFit="cover"
            />
            {/* Play Button */}
            <Box
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              width={{ base: '60px', md: '95px' }}
              height={{ base: '60px', md: '95px' }}
              backgroundImage="url('https://www.datocms-assets.com/46272/1733453032-playbutton.png')"
              backgroundSize="contain"
              backgroundRepeat="no-repeat"
              backgroundPosition="center"
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default function EmbedVideo({ sectionContent }) {
  const titleSectionContent = sectionContent[0];
  const videoSectionContent = sectionContent[1];

  return (
    <Box position="relative">
      <Box
        backgroundImage={{
          base: 'url("https://www.datocms-assets.com/46272/1733453358-ksbluebg.png")',
          md: 'url("https://www.datocms-assets.com/46272/1736444404-ksmediaembedtabbg.png")',
          xl: 'url("https://www.datocms-assets.com/46272/1733453358-ksbluebg.png")',
        }}
        bgRepeat="no-repeat"
        bgSize="cover"
        position="relative"
        zIndex="1"
        height={{ base: '300px', md: '583px' }}
      >
        <Box
          color="#ECBD47" // Text and decoration color
          textAlign="center"
          py={{ base: '44px', md: '60px', lg: '45px' }}
          px={{base:2, sm:4}}
          position="relative"
          mt="10px"
        >
          <Heading
            as="h1"
            fontSize={{ base: '30px', md:"38px", xl: '44px' }}
            lineHeight={{ base: '31px', md:"41.8px", xl: '48px' }}
            fontWeight="700"
            fontFamily="Fedra Serif Display"
            letterSpacing="0.05em"
            mt="10px"
          >
            {titleSectionContent.titleText}
          </Heading>

          <Text
            fontSize={{ base: '20px', md: '24px' }}
            lineHeight={{ base: '32px', md: '30px' }}
            color="#FFFFFF"
            fontWeight="450"
            fontFamily="FedraSansStd-book"
            mt={{ base: '13px', md: '15px', lg: '17px' }}
            width={{ base: '90%', md: '100%' }}
            textAlign="center"
            mx="auto"
          >
            {titleSectionContent.titleSubtext}
          </Text>

          <Image
            src="https://www.datocms-assets.com/46272/1733201483-sankalpa-flower.png"
            alt="sankalpa-flower"
            width={{ base: '167px', md: '212px' }}
            mt={{ base: '13px', md: '30px', xl: '20px' }}
          />
        </Box>
      </Box>

      <Box
        position="relative"
        zIndex="3"
        marginTop={{ base: '-53px', md: '-450px' }}
        pt={{ base: '', md: '130px' }}
      >
        <Video sectionContent={videoSectionContent} />
        <Box
          textAlign={{ base: 'left', md: 'center' }}
          display="flex"
          justifyContent="center"
          mt="30px"
          pb={{ base: '', md: '30px', xl: '30px' }}
        >
          <Box
            width={{ base: '85%', md: '560px', xl: '60%' }}
            textAlign={{ base: 'left', md: 'center' }}
          >
            <StructuredTextParser
              str={render(sectionContent[2].body)}
              textAlign={{ base: 'left', md: 'center' }}
              color="#000000"
              fontWeight='500'
              fontFamily="FedraSansStd-book, sans-serif"
              fontSize={{ base: '18px', md: '18px', lg: '20px' }}
              lineHeight={{ base: '33px', md: '33px', lg: '36.8px' }}
              sx={{
                strong: {
                  color: '#031430', 
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        bgImage="https://www.datocms-assets.com/46272/1733453359-kspinkbg.png"
        position="relative"
        zIndex="0"
        marginTop="-500px"
        height="550px"
      ></Box>
    </Box>
  );
}
